import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import swal from 'sweetalert2';
import { withRouter } from 'react-router-dom';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import User from '_class/User';
import getEnvironment from 'lib/env';
import { getToken, loginRequest, http } from 'lib/msal';
import { submit_preschooldocument, update_preschooldocument, deleteDocumentationFile } from 'actions/documents';
import { getPlanDetails, getPlansBySectionId } from 'actions/plans';
import { getSection, getSections } from 'actions/sections';
import DropzoneComponent from 'react-dropzone-component';
import FileItem from 'components/FileItem';
import GroupUserSelect from 'components/List/GroupUserSelect';
import UserSelect from 'components/List/UserSelect';
import SearchPreschoolGoals from './SearchPreschoolGoals';
import { Expandable, List } from 'UI';
import { Close, Image } from 'UI/Icons';
import { Editor } from 'UI/Inputs';
import { Button, Icon, Radio } from '@haldor/ui';

var Documentation = /*#__PURE__*/function (_Component) {
  _inherits(Documentation, _Component);

  var _super = _createSuper(Documentation);

  function Documentation(props) {
    var _this;

    _classCallCheck(this, Documentation);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (value != null && value !== '') {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "quillValidation", function (value) {
      var strValue = value;
      var text = '';

      if (typeof strValue == 'string') {
        text = strValue.replace(/<(?:.|\n)*?>/gm, '');
      }

      if (text == "" || text == null) {
        return _this.props.translate('needs-description');
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "validateRelationships", function (value) {
      if (value == null || value == '') {
        return _this.props.translate('select-relation-error');
      }

      if (value.length == 0) {
        return _this.props.translate('select-relation-error');
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.sections == null) {
        _this.props.getSections();
      }

      var sectionId = null;

      if (_this.props.section != null) {
        sectionId = _this.props.section.id;
      }

      if (_this.props.sectionId != null) {
        sectionId = _this.props.sectionId;
      }

      if (sectionId != null) {
        _this.props.getPlansBySectionId(sectionId);
      }

      if (_this.props.planId != null) {
        _this.props.getPlanDetails(_this.props.planId).then(function () {
          var plan = _this.props.plan;
          var goals = [];
          plan.associatedGoals.map(function (goal) {
            goals.push({
              goalId: goal.goalId
            });
          });

          _this.setState({
            selectedGoals: goals
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onModalClose) {
        _this.props.onModalClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        if (values.relationships == null || values.relationships.length == 0) {
          _this.setState({
            error: _this.props.translate('select-relation-error') + '!'
          });

          resolve(0);
          return false;
        }

        var initialValues = _this.props.initialValues;
        var isEditing = initialValues != null && Object.keys(initialValues).length > 1 && initialValues.id != null;
        var user = new User(_this.props.currentUser);

        if (_this.dropzone && _this.dropzone.getQueuedFiles().length > 0) {
          _this.dropzone.on('totaluploadprogress', function (progress) {
            _this.setState({
              uploadProgress: progress
            });
          });

          var that = _assertThisInitialized(_this);

          _this.readyForSubmit(values).then(function (data) {
            var url = "".concat(http.defaults.baseURL, "documentations/").concat(data, "/files?schoolId=").concat(user.getActiveSchool().id);

            if (isEditing) {
              url = "".concat(http.defaults.baseURL, "documentations/").concat(initialValues.id, "/files?schoolId=").concat(user.getActiveSchool().id);
            }

            _this.componentConfig.postUrl = url;
            _this.dropzone.options.url = url;

            _this.dropzone.processQueue();

            _this.dropzone.on("queuecomplete", function (images) {
              if (isEditing) {
                if (that.props.onModalClose) {
                  that.props.onModalClose(true, true);
                }
              } else {
                _this.props.history.push("/preschooldocument/".concat(data));
              }

              resolve(data);
            });
          });
        } else {
          var _that = _assertThisInitialized(_this);

          _this.readyForSubmit(values).then(function (data) {
            if (isEditing) {
              if (_that.props.onModalClose) {
                _that.props.onModalClose(true, true);
              }
            } else {
              _this.props.history.push("/preschooldocument/".concat(data));
            }

            resolve(data);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "readyForSubmit", function (values, callback) {
      return new Promise(function (resolve, reject) {
        var _this$state = _this.state,
            selectedGoals = _this$state.selectedGoals,
            PlanId = _this$state.PlanId,
            removedFiles = _this$state.removedFiles;
        var _this$props = _this.props,
            submit_preschooldocument = _this$props.submit_preschooldocument,
            update_preschooldocument = _this$props.update_preschooldocument,
            initialValues = _this$props.initialValues,
            currentUser = _this$props.currentUser;
        var goalIds = selectedGoals;
        /* Add custom inputs to the values object that redux form creates */

        values.associatedGoals = goalIds;
        values.planId = PlanId;

        if (values.status == null) {
          values.status = 'DOCUMENTATION_PUBLISHED';
        }

        if (values.sender != null) {
          if (values.sender == 'me') {
            values.author = currentUser.firstName + ' ' + currentUser.lastName;
          }

          delete values.sender;
        } // Check for initialValues and make sure we have an id


        if (Object.keys(initialValues).length > 1 && initialValues.id != null) {
          // If the goals hasn't changed during the update we
          // just fetch the existing goals on the documentation and send them back
          if (goalIds.length < 1) {
            goalIds = initialValues.associatedGoals;
          }

          if (removedFiles.length > 0) {
            removedFiles.map(function (file) {
              _this.props.deleteDocumentationFile(values.id, file.id);
            });
          }

          values.associatedGoals = goalIds;
          update_preschooldocument(values, function (data) {
            resolve(data);
          });
        } else {
          submit_preschooldocument(values, function (data) {
            resolve(data);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGoalsChange", function (selectedGoals) {
      _this.setState({
        selectedGoals: selectedGoals
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPlanChange", function (event) {
      if (event.target.value != _this.state.PlanId) {
        _this.props.getPlanDetails(event.target.value).then(function () {
          var plan = _this.props.plan;
          var goals = [];
          plan.associatedGoals.map(function (goal) {
            goals.push({
              goalId: goal.goalId
            });
          });

          _this.setState({
            selectedGoals: goals
          });
        });

        _this.setState({
          PlanId: event.target.value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "dropzoneInit", function (dropzone) {
      _this.dropzone = dropzone;
    });

    _defineProperty(_assertThisInitialized(_this), "onAddFile", function (file) {
      var Files = _this.state.Files;

      if (file.size > 101000024) {
        _this.dropzone.removeFile(file); // File over 100MB


        swal.fire({
          title: _this.props.translate('file-too-big'),
          showCancelButton: false,
          confirmButtonText: _this.props.translate('okey')
        });
        return false;
      }

      Files.push(file);
      setTimeout(function () {
        _this.setState({
          Files: Files
        });
      }, 40);
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveFile", function (file) {
      var Files = _this.state.Files;
      var fileIndex = Files.findIndex(function (f) {
        return f.upload.filename === file.upload.filename;
      });
      Files.splice(fileIndex, 1);

      _this.setState({
        Files: Files
      }, function () {
        if (_this.dropzone) {
          _this.dropzone.removeFile(file);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeFileFromDocument", function (file) {
      var _this$state2 = _this.state,
          removedFiles = _this$state2.removedFiles,
          uploadedFiles = _this$state2.uploadedFiles;

      if (file != null) {
        uploadedFiles = uploadedFiles.filter(function (f) {
          return f.id != file.id;
        });
        removedFiles.push(file);

        _this.setState({
          removedFiles: removedFiles,
          uploadedFiles: uploadedFiles
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      }, input)), touched && (error && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTextarea", function (_ref2) {
      var input = _ref2.input,
          label = _ref2.label,
          type = _ref2.type,
          placeholder = _ref2.placeholder,
          _ref2$meta = _ref2.meta,
          touched = _ref2$meta.touched,
          error = _ref2$meta.error,
          warning = _ref2$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("textarea", _extends({}, input, {
        placeholder: placeholder || label,
        type: type
      }), input.value), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem'
        }
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "relationChange", function (event) {
      var PlanId = _this.state.PlanId;
      var sectionRelations = [];
      var relations = Object.values(event);
      relations.map(function (rel) {
        if (rel.referenceType == 'SECTION') {
          sectionRelations.push(rel);
        }

        if (rel.referenceType == 'USER') {
          sectionRelations.push(rel);
        }
      });

      if (sectionRelations.length > 0) {
        var firstReference = sectionRelations[0];
        var sectionId = null;

        if (firstReference.referenceType == 'USER') {
          sectionId = firstReference.parentId;
        } else {
          sectionId = firstReference.referenceId;
        }

        if (_this.state.sectionPlans != sectionId) {
          _this.props.getPlansBySectionId(sectionId);

          _this.setState({
            sectionPlans: sectionId
          });
        }
      }

      if (sectionRelations.length > 1 && PlanId != null) {
        if (_this.props.section == null) {
          _this.setState({
            PlanId: null,
            selectedGoals: []
          });
        }
      }

      _this.setState({
        sectionRelations: sectionRelations
      });
    });

    _defineProperty(_assertThisInitialized(_this), "triggerDropzone", function () {
      if (_this.dropzone != null) {
        _this.dropzone.hiddenFileInput.click();
      }
    });

    var _isEditing = props.initialValues != null && Object.keys(props.initialValues).length > 1;

    var _uploadedFiles = [];
    var defaultPlan = null;

    if (props.initialValues != null && props.initialValues.associatedFiles != null) {
      _uploadedFiles = props.initialValues.associatedFiles;
    }

    if (props.initialValues != null && props.initialValues.planId != null) {
      defaultPlan = props.initialValues.planId;
    } else if (props.planId != null) {
      defaultPlan = props.planId;
    }

    _this.state = {
      selectedGoals: _isEditing ? props.initialValues.associatedGoals : [],
      Files: [],
      PlanId: defaultPlan,
      uploadedFiles: _uploadedFiles,
      removedFiles: [],
      sectionRelations: [],
      error: null,
      uploadProgress: null,
      sectionPlans: null
    };
    _this.dropzone = null;
    /* Configure dropzone component */

    _this.componentConfig = {
      iconFiletypes: ['.jpg', '.png', '.gif'],
      showFiletypeIcon: false,
      postUrl: http.defaults.baseURL + 'fileItems',
      dropzoneSelector: '.dropzone-trigger'
    };
    _this.djsConfig = {
      autoProcessQueue: false,
      parallelUploads: 1,
      timeout: 99900000,
      headers: {}
    };
    var request = loginRequest;
    request.scopes = [].concat(_toConsumableArray(getEnvironment().scopes), _toConsumableArray(request.scopes));
    getToken(request).then(function (response) {
      _this.djsConfig.headers['Authorization'] = 'Bearer ' + response.accessToken;
    });
    _this.dropzoneEvents = {
      init: _this.dropzoneInit,
      addedfile: _this.onAddFile,
      success: function success() {
        _this.dropzone.processQueue();
      }
    };
    return _this;
  }
  /* Redux form functions */


  _createClass(Documentation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          sections = _this$props2.sections,
          initialValues = _this$props2.initialValues,
          currentUser = _this$props2.currentUser;
      var _this$state3 = this.state,
          Files = _this$state3.Files,
          uploadedFiles = _this$state3.uploadedFiles,
          PlanId = _this$state3.PlanId,
          sectionRelations = _this$state3.sectionRelations;
      var isEditing = initialValues != null && initialValues.id != null;

      if (sectionRelations != null && sectionRelations.length > 0) {
        sectionRelations = sectionRelations.filter(function (rel) {
          return rel.referenceType == 'SECTION';
        });
      }

      if (isEditing) {
        var author = this.props.initialValues.author;
        initialValues.sender = author == currentUser.firstName + ' ' + currentUser.lastName ? 'me' : 'custom';
      } else {
        initialValues.sender = 'me';
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement(Form, {
        onSubmit: this.submit,
        initialValues: initialValues,
        initialValuesEqual: function initialValuesEqual() {
          return true;
        },
        mutators: {
          setStatusDraft: function setStatusDraft(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'DOCUMENTATION_DRAFT';
            });
          },
          setStatusPublished: function setStatusPublished(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'DOCUMENTATION_PUBLISHED';
            });
          }
        },
        render: function render(_ref3) {
          var _form$getFieldState, _initialValues$associ;

          var form = _ref3.form,
              valid = _ref3.valid,
              handleSubmit = _ref3.handleSubmit,
              submitting = _ref3.submitting;
          var senderValue = (_form$getFieldState = form.getFieldState('sender')) === null || _form$getFieldState === void 0 ? void 0 : _form$getFieldState.value;
          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit,
            className: "form form-component"
          }, /*#__PURE__*/React.createElement(Expandable, {
            contentStyles: {
              padding: '1em 0rem'
            },
            contentStylesClosed: {
              padding: '0'
            },
            headerStyles: _this2.state.error != null ? {
              border: '1px solid red'
            } : {},
            whiteBackground: true,
            title: _this2.props.translate('groups-and-children') + '*',
            open: !isEditing,
            ignorePropsUpdate: true
          }, /*#__PURE__*/React.createElement(List, {
            style: {
              border: '0',
              margin: '0',
              boxShadow: 'none'
            }
          }, _this2.props.section != null ? /*#__PURE__*/React.createElement(List, {
            style: {
              border: '0',
              margin: '0',
              boxShadow: 'none'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            component: GroupUserSelect,
            name: "relationships",
            section: _this2.props.section,
            onChange: _this2.relationChange,
            validate: _this2.validateRelationships
          })) : /*#__PURE__*/React.createElement(List, {
            style: {
              border: '0',
              margin: '0',
              boxShadow: 'none'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            component: UserSelect,
            name: "relationships",
            sections: sections,
            userSelectDisabled: false,
            selectMultipleSchools: _this2.props.selectMultipleSchools,
            onChange: _this2.relationChange,
            validate: _this2.validateRelationships
          })))), _this2.state.error != null ? /*#__PURE__*/React.createElement("div", {
            className: "form-row error"
          }, _this2.state.error) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('planning')), /*#__PURE__*/React.createElement("div", {
            className: "select"
          }, /*#__PURE__*/React.createElement("select", {
            onChange: _this2.onPlanChange,
            value: PlanId,
            disabled: _this2.props.planId || isEditing ? true : sectionRelations.length > 1 ? true : false
          }, /*#__PURE__*/React.createElement("option", {
            value: ""
          }, _this2.props.translate('pick-a-plan')), _this2.props.sectionPlans !== null ? _this2.props.sectionPlans.map(function (plan) {
            return /*#__PURE__*/React.createElement("option", {
              key: plan.id,
              value: plan.id
            }, plan.title);
          }) : null))), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('Sender')), /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'inline-block'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            component: Radio,
            name: "sender",
            label: _this2.props.currentUser.firstName + ' ' + _this2.props.currentUser.lastName,
            optionValue: "me"
          })), /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'inline-block',
              marginLeft: '.85rem'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            component: Radio,
            name: "sender",
            optionValue: "custom",
            label: _this2.props.translate('Free text') + (senderValue == 'custom' ? '*' : '')
          }))), senderValue == 'custom' ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              marginTop: '.35rem'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            name: "author",
            type: "text",
            component: _this2.renderInput,
            validate: _this2.required
          })) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('title'), "*"), /*#__PURE__*/React.createElement(Field, {
            name: "title",
            type: "text",
            component: _this2.renderInput,
            placeholder: _this2.props.translate('title'),
            validate: _this2.required
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('description')), /*#__PURE__*/React.createElement(Field, {
            component: Editor,
            name: "description",
            placeholder: _this2.props.translate('description'),
            translate: _this2.props.translate
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('add-images-and-files')), /*#__PURE__*/React.createElement("div", {
            className: "dropzone-trigger icon-container",
            style: {
              height: 'auto',
              width: '100%'
            }
          }, /*#__PURE__*/React.createElement("div", {
            onClick: _this2.triggerDropzone,
            className: "icon"
          }, /*#__PURE__*/React.createElement(Image, null)), /*#__PURE__*/React.createElement("div", {
            className: "text",
            onClick: _this2.triggerDropzone
          }, _this2.props.translate('drop-files-or-click-here')), /*#__PURE__*/React.createElement(DropzoneComponent, {
            djsConfig: _this2.djsConfig,
            eventHandlers: _this2.dropzoneEvents,
            config: _this2.componentConfig
          })), /*#__PURE__*/React.createElement("div", {
            style: {
              clear: 'both'
            }
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, Files && Files.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('images-needs-uploading'))), /*#__PURE__*/React.createElement("div", {
            style: {
              marginLeft: '-0.5rem',
              marginRight: '-0.5em',
              display: 'flex'
            }
          }, Files.map(function (file) {
            return /*#__PURE__*/React.createElement("div", {
              key: file.lastModified,
              style: file.type.indexOf('image') > -1 ? {
                background: "url(".concat(file.dataURL, ")")
              } : {},
              className: "dropzone-file-preview ".concat(!file.accepted ? " not-accepted" : "", " ").concat(file.upload.progress > 0 ? ' upload-started' : ' not-started', " ").concat(file.type.indexOf('image') > -1 ? ' image' : '')
            }, /*#__PURE__*/React.createElement("div", {
              className: "file-name"
            }, /*#__PURE__*/React.createElement("div", {
              style: {
                flex: 1,
                maxWidth: 'calc(100% - 1rem)',
                wordWrap: 'break-word'
              }
            }, file.name + ' ', "(", file.size > 100000 ? Math.round(file.size / 1024 / 1024) + 'MB' : Math.round(file.size / 1024) + 'Kb', ")"), /*#__PURE__*/React.createElement("div", {
              onClick: function onClick(e) {
                _this2.onRemoveFile(file);
              },
              className: "file-delete-btn"
            }, /*#__PURE__*/React.createElement(Close, null))), file.accepted && file.size > 7500000 ? /*#__PURE__*/React.createElement("div", {
              className: "file-warning"
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Info_Blue"
            }), /*#__PURE__*/React.createElement("div", {
              style: {
                flex: 1
              }
            }, _this2.props.translate('size-warning'))) : null, !file.accepted ? /*#__PURE__*/React.createElement("div", {
              className: "file-warning"
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Alert"
            }), /*#__PURE__*/React.createElement("div", {
              style: {
                flex: 1
              }
            }, _this2.props.translate('file-too-big'))) : null, file.type.indexOf('image') > -1 ? /*#__PURE__*/React.createElement("div", {
              className: "overlay"
            }) : null);
          }))) : null), isEditing && initialValues.associatedFiles != null ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              marginTop: '1rem'
            }
          }, uploadedFiles != null && uploadedFiles.length > 0 && (initialValues === null || initialValues === void 0 ? void 0 : (_initialValues$associ = initialValues.associatedFiles) === null || _initialValues$associ === void 0 ? void 0 : _initialValues$associ.length) > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('images-attached'))), /*#__PURE__*/React.createElement("div", {
            style: {
              marginLeft: '-0.5rem',
              marginRight: '-0.5em',
              display: 'flex'
            }
          }, uploadedFiles.map(function (file) {
            return /*#__PURE__*/React.createElement(FileItem, {
              element: "div",
              file: file,
              key: file.id,
              className: "dropzone-file-preview ".concat(file.type.indexOf('image') > -1 ? ' image' : '')
            }, /*#__PURE__*/React.createElement("div", {
              className: "file-name"
            }, /*#__PURE__*/React.createElement("div", {
              style: {
                flex: 1
              }
            }, file.name), /*#__PURE__*/React.createElement("div", {
              onClick: function onClick(e) {
                _this2.removeFileFromDocument(file);
              },
              className: "file-delete-btn"
            }, /*#__PURE__*/React.createElement(Close, null))), file.type.indexOf('image') > -1 ? /*#__PURE__*/React.createElement("div", {
              className: "overlay"
            }) : null);
          }))) : null) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('select-goals')), /*#__PURE__*/React.createElement(SearchPreschoolGoals, {
            selectedGoals: _this2.state.selectedGoals,
            onChange: _this2.onGoalsChange
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-row spacing submit"
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusPublished();
              form.submit();
            },
            disabled: submitting || !valid
          }, _this2.props.translate('publish')), isEditing && initialValues.status != "DOCUMENTATION_DRAFT" ? null : /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusDraft();
              form.submit();
            },
            type: "secondary",
            disabled: submitting || !valid
          }, _this2.props.translate("save-draft")), /*#__PURE__*/React.createElement("div", {
            className: "align-right"
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: _this2.onCancel,
            disabled: submitting,
            type: "secondary"
          }, _this2.props.translate('Cancel')))), submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }), /*#__PURE__*/React.createElement("br", null), _this2.state.uploadProgress != null ? /*#__PURE__*/React.createElement("div", {
            className: "upload-progress"
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              width: Math.round(_this2.state.uploadProgress) + '%'
            },
            className: "upload-progress-bar"
          })) : null)) : null);
        }
      }));
    }
  }]);

  return Documentation;
}(Component);

function mapStateToProps(state, ownProps) {
  var values = _objectSpread(_objectSpread({}, ownProps.values), state.Documents.activeDocument);

  return {
    currentUser: state.user.currentUser,
    initialValues: values,
    sectionPlans: state.planning.sectionPlans,
    plan: state.planning.active_plan,
    translate: translate(state.Languages.translations),
    sections: state.sections.educationGroups,
    preschoolDocuments: state.Posts.documents
  };
}

export default withRouter(connect(mapStateToProps, {
  submit_preschooldocument: submit_preschooldocument,
  update_preschooldocument: update_preschooldocument,
  getPlansBySectionId: getPlansBySectionId,
  getSection: getSection,
  getSections: getSections,
  deleteDocumentationFile: deleteDocumentationFile,
  getPlanDetails: getPlanDetails
})(Documentation));